export default __webpack_public_path__ + "static/media/Phones 2.96ecd50d.png";